<template lang="pug">
	.advanced-search
		hr.advanced-search__white-line
		div.advanced-search__col
			.search__field-wrap
				MultiSelect#multi-select-condition(
					:label="$t('AADAT.condition')",
					label-id="condition"
					v-model="model.conditionOfProperty",
					:placeholder="$t('ALIST.allTheSame')",
					:options="conditionTypes")
			.search__field-wrap
				MultiSelect#multi-select-heating(
					:label="$t('AADAT.heating')",
					label-id="heating"
					v-model="model.heating",
					:placeholder="$t('ALIST.allTheSame')",
					:options="heatingTypes")
			.search__field-wrap
					MultiSelect#multi-select-building-material(
						:label="$t('AADAT.buildingMaterial')"
						label-id="buildingMaterial"
						v-model="model.buildingStructure",
						:placeholder="$t('ALIST.allTheSame')",
						:options="buildingMaterials")
			.search__field-wrap
				MultiSelect#multi-select-comfort(
					:label="$t('AADAT.comfort')"
					label-id="comfortLevel"
					v-model="model.comfortLevel"
					:placeholder="$t('ALIST.allTheSame')",
					:options="comfortLevels")
			.search__field-wrap
				MultiSelect#multi-select-stairwell(
					:label="$t('AADAT.stairwell')"
					label-id="staircaseType"
					v-model="model.staircaseType"
					:placeholder="$t('ALIST.allTheSame')",
					:options="staircaseTypes")
		div.advanced-search__col
			.search__field-wrap
				MultiSelect#multi-select-orientation(
					:label="$t('AADAT.orientation')"
					label-id="livingRoomOrientation"
					v-model="model.livingRoomOrientation"
					:placeholder="$t('ALIST.allTheSame')",
					:options="orientationTypes")
			.search__field-wrap
				MultiSelect#multi-select-view(
					:label="$t('AADAT.view')"
					label-id="view"
					v-model="model.view"
					:placeholder="$t('ALIST.allTheSame')",
					:options="viewTypes")
			.search__field-wrap
				MultiSelect#multi-select-parking(
					:label="$t('AADAT.parking')"
					label-id="parkingOption"
					v-model="model.parkingOption"
					:placeholder="$t('ALIST.allTheSame')",
					:options="parkingTypes")
			.search__field-wrap
				MultiSelect#multi-select-inner-height(
					:label="$t('AADAT.innerHeight')"
					label-id="innerHeight"
					v-model="model.innerHeight"
					:placeholder="$t('ALIST.allTheSame')",
					:options="heightTypes")
			.search__field-wrap.search__field-wrap--checkbox
				VueCheckbox(v-model="model.webwalk") {{$t('AADAT.webWalk')}}
			.search__field-wrap.search__field-wrap--checkbox
				VueCheckbox(v-model="model.elevator") {{$t('AADAT.withElevator')}}
			.search__field-wrap.search__field-wrap--checkbox
				VueCheckbox(v-model="model.balcony") {{$t('AADAT.withBalconyOrTerrace')}}
		div.advanced-search__col.advanced-search-form
			.search__field-wrap.search__field-wrap--form
				fieldset.advanced-search-form__fieldset
					legend.advanced-search-form__label {{$t('AADAT.numberOfRooms')}}
					label.sr-only(for="search-room-type-min") Szobák száma minimum
					VueSelect.advanced-search-form__select.advanced-search-form__select--first(
							id="search-room-type-min"
							v-model="model.roomsMinimum"
						)
							VueSelectOption(v-for="(item, index) in roomValuesMin", :value="item.key", :text="item.value", :index="index", label-id="label1" :key="item.key")
					label.sr-only(for="search-room-type-max") Szobák száma maximum
					VueSelect.advanced-search-form__select(
							id="search-room-type-max"
							v-model="model.roomsMaximum"
						)
							VueSelectOption(v-for="(item, index) in roomValuesMax", :value="item.key", :text="item.value", :index="index", label-id="label1" :key="item.key")
			.search__field-wrap.search__field-wrap--form
				fieldset.advanced-search-form__fieldset
					legend.advanced-search-form__label {{$t('AADAT.numberOfBathrooms')}}
					label.sr-only(for="search-bathroom-type-min") Fürdőszobák száma minimum
					VueSelect.advanced-search-form__select.advanced-search-form__select--first(
							id="search-bathroom-type-min"
							v-model="model.bathroomsMinimum"
						)
							VueSelectOption(v-for="(item, index) in bathroomValuesMin", :value="item.key", :text="item.value", :index="index", label-id="label1" :key="item.key")
					label.sr-only(for="search-bathroom-type-max") Fürdőszobák száma maximum
					VueSelect.advanced-search-form__select(
							id="search-bathroom-type-max"
							v-model="model.bathroomsMaximum"
						)
							VueSelectOption(v-for="(item, index) in bathroomValuesMax", :value="item.key", :text="item.value", :index="index", label-id="label1" :key="item.key")
			.search__field-wrap.search__field-wrap--form(v-if="hasFloorSelect")
				fieldset.advanced-search-form__fieldset
					legend.advanced-search-form__label {{$t('AADAT.floor')}}
					label.sr-only(for="search-floor-type-min") Minimum szint
					VueSelect.advanced-search-form__select.advanced-search-form__select--first(
							id="search-floor-type-min"
							v-model="model.floorsInBuildingMinimum"
						)
							VueSelectOption(v-for="(item, index) in floorsTypes", :value="item.key", :text="item.value", :index="index", label-id="label1" :key="item.key")
					label.sr-only(for="search-floor-type-max") Maximum szint
					VueSelect.advanced-search-form__select(
							id="search-floor-type-max"
							v-model="model.floorsInBuildingMaximum"
						)
							VueSelectOption(v-for="(item, index) in floorsTypes", :value="item.key", :text="item.value", :index="index", label-id="label1" :key="item.key")
			.search__field-wrap.search__field-wrap--form
				label.advanced-search-form__label {{$t('AADAT.keyword')}}
				VueInput#advanced-search-keyword(v-model="model.keyWord" :placeholder="$t('ALIST.keywordExample')")
			.search__field-wrap.search__field-wrap--form
				label.advanced-search-form__label {{$t('AADAT.mnumber')}}
				VueInput#advanced-search-comission-id(v-model="model.comissionId" :placeholder="$t('ALIST.mnumberExample')")
		.search__cta-wrap
			VueButton.reset-button(buttonType="link" @click="reset") {{$t('ALIST.resetDefault')}}
			VueButton.search-advanced__search-button(v-if="!isMobile", buttonType="highlighted", @click="send") {{$t('ANYIT.search')}}

</template>
<script>
import * as R from 'ramda';
import MultiSelect from '../../../common/components/multi-select/MultiSelect';
import VueCheckbox from '@ui-common/vue-checkbox';
import VueButton from '@ui-common/vue-button';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import VueInput from '@ui-common/vue-input';
import lang from '../../../common/js/lang/lang';
import isMobile from '../../../common/js/is-mobile/is-mobile';
const CONDITION_TYPES = ['uninhabitable', 'toRenew', 'average', 'good', 'excellent', 'newlyBuilt'];
const HEATING_TYPES = ['gas', 'electric', 'remoteHeating', 'houseCentralized', 'otherHeating'];
const BUILDING_MATERIALS = ['wood', 'brick', 'panel', 'shutter', 'lightStructure', 'otherBuildingMaterial'];
const COMFORT_LEVELS = ['doubleComfort', 'fullComfort', 'other'];
const STAIRCASE_TYPES = ['closed', 'circularCorridor', 'other'];
const ORIENTATION_TYPES = ['north', 'east', 'south', 'west'];
const VIEW_TYPES = ['street', 'yard', 'garden', 'panorama'];
const PARKING_TYPES = ['roomGarage', 'closedPlace', 'openedPlace', 'publicPayment', 'publicFree'];
const FLOOR_TYPES = [
	'underground4',
	'underground3',
	'underground2',
	'underground1',
	'basement',
	'suteren',
	'halfSuteren',
	'downstairs',
	'highDownstairs',
	'halfUpstairs',
	'1',
	'2',
	'3',
	'4',
	'5',
	'6',
	'7',
	'8',
	'9',
	'10',
	'10+'
];
const PROPERTIES_WITHOUT_FLOOR = ['house'];
const HEIGHT_TYPES = ['heightLow', 'heightNormal', 'heightExtra', 'heightLoft'];
const mapToString = R.map(R.toString);
const ROOM_VALUES = R.compose(mapToString, R.range)(1, 11);
const BATHROOM_VALUES = R.compose(R.append('2+'), mapToString, R.range)(0, 3);
const translateAADAT = (key) => lang.t(`AADAT.${key}`);
const translateALIST = (key) => lang.t(`ALIST.${key}`);
const mapOptionsAADAT = R.map(R.applySpec({ key: R.identity, value: translateAADAT }));
const mapOptionsALIST = R.map(R.applySpec({ key: R.identity, value: translateALIST }));
const mapOptionsSameValue = R.map(R.applySpec({ key: R.identity, value: R.identity }));
const EMPTY_MODEL = {
	conditionOfProperty: [],
	heating: [],
	buildingStructure: [],
	comfortLevel: [],
	staircaseType: [],
	livingRoomOrientation: [],
	view: [],
	parkingOption: [],
	other: [],
	roomsMinimum: '1',
	roomsMaximum: '10+',
	bathroomsMinimum: '0',
	bathroomsMaximum: '2+',
	floorsInBuildingMinimum: FLOOR_TYPES[7],
	floorsInBuildingMaximum: FLOOR_TYPES[FLOOR_TYPES.length - 1],
	webwalk: false,
	elevator: false,
	balcony: false,
	keyWord: null,
	comissionId: null,
	innerHeight: []
};
export default {
	mixins: [isMobile],
	props: {
		value: {
			required: true
		},
		propertyType: {
			required: true
		}
	},
	data: () => ({
		model: R.clone(EMPTY_MODEL)
	}),
	components: {
		MultiSelect,
		VueCheckbox,
		VueSelect,
		VueSelectOption,
		VueButton,
		VueInput
	},
	watch: {
		value: {
			handler(val) {
				this.model = R.merge(this.model, val);
			},
			immediate: true
		},
		propertyType: {
			handler(val) {
				if (PROPERTIES_WITHOUT_FLOOR.includes(val)) {
					this.model.floorsInBuildingMinimum = null;
					this.model.floorsInBuildingMaximum = null;
				} else {
					this.model.floorsInBuildingMinimum = FLOOR_TYPES[7];
					this.model.floorsInBuildingMaximum = FLOOR_TYPES[FLOOR_TYPES.length - 1];
				}
			},
			immediate: true
		}
	},
	computed: {
		conditionTypes: () => mapOptionsAADAT(CONDITION_TYPES),
		heatingTypes: () => mapOptionsAADAT(HEATING_TYPES),
		buildingMaterials: () => mapOptionsAADAT(BUILDING_MATERIALS),
		comfortLevels: () => mapOptionsAADAT(COMFORT_LEVELS),
		staircaseTypes: () => mapOptionsAADAT(STAIRCASE_TYPES),
		orientationTypes: () => mapOptionsAADAT(ORIENTATION_TYPES),
		viewTypes: () => mapOptionsAADAT(VIEW_TYPES),
		parkingTypes: () => mapOptionsAADAT(PARKING_TYPES),
		heightTypes: () => mapOptionsAADAT(HEIGHT_TYPES),
		roomValuesMin: () => mapOptionsSameValue(ROOM_VALUES),
		roomValuesMax: () => R.append({ key: '10+', value: translateALIST('10plus') }, mapOptionsSameValue(ROOM_VALUES)),
		bathroomValuesMin: () => R.init(mapOptionsSameValue(BATHROOM_VALUES)),
		bathroomValuesMax: () => mapOptionsSameValue(BATHROOM_VALUES),
		floorsTypes: () => mapOptionsALIST(FLOOR_TYPES),
		hasFloorSelect() {
			return !PROPERTIES_WITHOUT_FLOOR.includes(this.propertyType);
		}
	},
	methods: {
		send() {
			this.$emit('input', this.model);
		},
		reset() {
			this.model = R.clone(EMPTY_MODEL);
		}
	}
};
</script>
<style src="@ui-common/vue-input/dist/vue-input.css"></style>
<style lang="css" scoped>
@import '../../../common/variables.pcss';

.advanced-search {
	background-color: var(--grey-f5);
	margin: 0 -16px;
	@media (--desktop) {
		padding-top: 14px;
		max-width: 1048px;
		margin: 0 auto;
	}
}

.advanced-search__white-line {
	background: var(--white);
	margin: 0 -116px;
	height: 4px;
	margin-bottom: 16px;
	display: none;

	@media (--desktop) {
		display: block;
	}
}

.advanced-search__col {
	@media (--desktop) {
		display: inline-block;
		vertical-align: top;
		width: 33.333%;
		padding-right: 9.35%;
	}
}

.search__field-wrap {
	margin-bottom: 4px;
	min-height: 70px;
}

.search__field-wrap--checkbox {
	padding: 23px 16px;

	& >>> .sf-checkbox {
		margin: 0;
	}
}

.search__cta-wrap {
	margin-top: 46px;
	text-align: center;
	margin-bottom: 90px;

	@media (--desktop) {
		margin-bottom: 40px;
	}
}
.reset-button {
	position: relative;
	text-decoration: none;
	font-family: 'regular', Arial, sans-serif;
	@media (--desktop) {
		margin-right: 32px;
	}
}

.reset-button::before {
	content: url('/static/assets/img/reload-arrow.svg');
	left: -21px;
	position: absolute;
	top: 2px;
}

.advanced-search .search-advanced__search-button {
	border-radius: 4px;
	font-size: 16px;
	font-weight: normal;
	padding: 10px 20px;
	width: 166px;
	font-family: 'semibold', Arial, sans-serif;
}

.advanced-search__col.advanced-search-form {
	padding-right: 3.5%;
	padding-top: 16px;
}

.search__field-wrap--form {
	margin-bottom: 20px;
	padding: 0 20px;
}

.advanced-search-form__label {
	display: block;
	font-weight: 600;
	margin-bottom: 8px;
	text-transform: uppercase;
}

.search__field-wrap.search__field-wrap--form >>> input::placeholder {
	color: #a4a4a4;
	opacity: 0.5;
}

.advanced-search-form__fieldset {
	border: 0;
	margin: 0;
	padding: 0;
}

.advanced-search-form .search__field-wrap >>> .advanced-search-form__select {
	display: inline-block;
	width: calc(50% - 4px);
}
.advanced-search-form .search__field-wrap >>> .advanced-search-form__select--first {
	margin-right: 8px;
}
</style>
